(ns practitest.frontend.summary.main
  (:require [re-frame.core :as re-frame]
            [practitest.frontend.summary.events :as events]
            [practitest.frontend.summary.views :as views]))

(defn index-view []
  [views/page])

(defn- fetch-url-tab! []
  (let [tab-id (.get (js/URLSearchParams. (.-search js/window.location)) "id")]
    (re-frame/dispatch [::events/fetch tab-id])))

;; Coming back with the browser Back (e.g. Save & Close on the item settings page calls history.back)
;; can restore this page from the back/forward cache with its old state - no request runs and the
;; controller doesn't start again, so refetch the tab then
(defn- on-page-show [^js e]
  (when (.-persisted e) ; only for a restore from the back/forward cache
    (fetch-url-tab!)))

(defn page-controller []
  {:start (fn [_]
            (.addEventListener js/window "pageshow" on-page-show)
            (fetch-url-tab!))
   :stop  (fn [_]
            (.removeEventListener js/window "pageshow" on-page-show)
            (re-frame/dispatch [::events/reset]))})
